import css from '@styled-system/css';

import { withComponentTheme } from './withComponentTheme';

type StyleProps = Record<string, unknown>;

export const componentCss =
  (styles: StyleProps) =>
  <T extends { theme?: unknown }>(props: T) =>
    css(styles)(withComponentTheme(props).theme);
